'use client';

import { c as _c } from "react/compiler-runtime";
import { Spinner } from '@achra/ui/spinner';
function FullPageSpinner() {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div className="flex min-h-[320px] items-center justify-center"><Spinner className="text-muted-foreground size-6" /></div>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
}
export { FullPageSpinner };